import { observer } from "mobx-react-lite/dist"
import { useProposalsEditRecipientsStore } from "./ProposalsEditRecipientsStore"
import SkeletonLoader from "reusable/mui/skeleton/SkeletonLoader"
import CreateClientContactAutocomplete from "features/clients/create/contact/CreateClientContactAutocomplete"

export default observer(function ProposalsEditRecipientsSelectContacts() {
   const proposalsEditRecipientsStore = useProposalsEditRecipientsStore()

   if (proposalsEditRecipientsStore.fields.advisorClientId === "") {
      return null
   }

   return <SkeletonLoader loading={proposalsEditRecipientsStore.clientUserLoader.isLoading}>
      {proposalsEditRecipientsStore.formHandler.recipientUserIds.bindInput(ip =>
         <CreateClientContactAutocomplete
            {...ip}
            label="Find contacts*"
            advisorClientId={proposalsEditRecipientsStore.fields.advisorClientId}
            onChange={proposalsEditRecipientsStore.onContactIdsChange}
            clientUsers={proposalsEditRecipientsStore.clientContactOptions}
            dontFetchContacts
         />
      )}
   </SkeletonLoader>
})
